import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=489da305&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"
import style0 from "./Cell.vue?vue&type=style&index=0&id=489da305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489da305",
  null
  
)

export default component.exports